import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';
import { convertMillisToHoursMinutes } from 'src/app/@core/utils/convertMillisToHoursMinutes.functions';
import {
  DatatableColumn,
  DatatableColumnType,
  SearchControl,
  SearchControlType,
  StringMap,
} from 'src/app/@theme/datatable/datatable.component';

export interface BranchChampionsRow {
  room: string;
  month: string;
  easy?: ResultInfo;
  medium?: ResultInfo;
  hard?: ResultInfo;
  master?: ResultInfo;
}

type ResultInfo = { picture: string; teamName: string; time: string };

@Component({
  selector: 'app-branchchampions',
  templateUrl: './branchchampions.component.html',
  styleUrls: ['./branchchampions.component.scss'],
})
export class BranchChampionsComponent {
  branchChampions: any[] = [];
  branchChampion: BranchChampionsRow[] = [];
  searchControlSettings: SearchControl[] = [];
  searchable: boolean = false;
  @Input() loading: boolean = false;
  @Input() theme: string = '';

  @HostBinding('class.light-theme') get isLightTheme() {
    return this.theme === 'light';
  }
  @HostBinding('class.dark-theme') get isDarkTheme() {
    return this.theme === 'dark';
  }

  columns: DatatableColumn[] = [
    { prop: 'room', name: 'ROOM', width: 125 },
    { prop: 'easy', name: 'Easy', width: 125, type: DatatableColumnType.ARRAY },
    {
      prop: 'medium',
      name: 'Medium',
      width: 125,
      type: DatatableColumnType.ARRAY,
    },
    { prop: 'hard', name: 'Hard', width: 125, type: DatatableColumnType.ARRAY },
    {
      prop: 'x_hard',
      name: 'Master',
      width: 125,
      type: DatatableColumnType.ARRAY,
    },
  ];

  private buildSearchControlSettings(): void {
    if (!this.branchChampions) {
      return;
    }

    const today = new Date();
    const months: StringMap = {};

    for (let i = 0; i < 4; i++) {
      const dateKey =
        today.getFullYear() +
        '.' +
        String(today.getMonth() + 1).padStart(2, '0') +
        '.';
      const dateValue = today.toLocaleString('en-US', {
        year: 'numeric',
        month: 'long',
      });

      months[dateKey] = dateValue;
      today.setMonth(today.getMonth() - 1);
    }

    this.searchControlSettings = [
      {
        title: 'Month',
        type: SearchControlType.SELECT,
        property: 'month',
        options: months,
      },
    ];
  }

  @Input('branchChampions') set setBranchChampions(branchChampions: any[]) {
    this.branchChampions = branchChampions;
    this.buildSearchControlSettings();
    this.mapBranchChampionRows();
  }

  @Output() filterChange = new EventEmitter<any>();

  private mapBranchChampionRows(): void {
    if (this.branchChampions) {
      const result: BranchChampionsRow[] = [];

      this.branchChampions.forEach((champion) => {
        champion.data!.forEach(
          (entry: {
            room: string;
            month: string;
            time: string;
            picture: any;
            teamName: any;
            level: string;
          }) => {
            const existingRoom = result.find(
              (item) => item.room === entry.room,
            );
            const timeInHoursAndMinutes = convertMillisToHoursMinutes(
              entry.time,
            );
            const picture = entry.picture
              ? entry.picture
              : '../../../../assets/noteampicture.png';
            const teamName = entry.teamName;
            const room = entry.room;
            const month = entry.month;
            if (!existingRoom) {
              const newRoomObj = {
                room,
                month,
                easy: { picture: '', teamName: '', time: '' },
                medium: { picture: '', teamName: '', time: '' },
                hard: { picture: '', teamName: '', time: '' },
                x_hard: { picture: '', teamName: '', time: '' },
              };
              (newRoomObj as any)[entry.level?.toLowerCase()] = {
                picture,
                teamName,
                timeInHoursAndMinutes,
              };
              result.push(newRoomObj);
            } else {
              (existingRoom as any)[entry.level?.toLowerCase()] = {
                picture,
                teamName,
                timeInHoursAndMinutes,
              };
            }
          },
        );
      });

      this.branchChampion = result.sort((a, b) => (a.room < b.room ? -1 : 1));
    }
  }

  onFilterChange(event: any): void {
    this.filterChange.emit(event);
  }
}
